module.exports = __webpack_public_path__ + "media/images/warnings/warning_2-faa068bf30dc6e87c9e6c191d86336c5.svg";